import { raise } from '@sparkdotfi/common-universal'
import { arbitrum, base, optimism, unichain } from 'viem/chains'

import { Token } from '@/domain/types/Token'
import { TokenSymbol } from '@/domain/types/TokenSymbol'

export type SwapActionPath =
  | 'dai-usds'
  | 'usds-dai'
  | 'dai-usdc'
  | 'usdc-dai'
  | 'usdc-usds'
  | 'usds-usdc'
  | 'base-usdc-usds'
  | 'base-usds-usdc'
  | 'arbitrum-usdc-usds'
  | 'arbitrum-usds-usdc'
  | 'optimism-usdc-usds'
  | 'optimism-usds-usdc'
  | 'unichain-usdc-usds'
  | 'unichain-usds-usdc'

export interface GetPsmConvertActionPathParams {
  inToken: Token
  outToken: Token
  chainId: number
}

export function getSwapActionPath({ from, to, chainId }: { from: Token; to: Token; chainId: number }): SwapActionPath {
  const dai = TokenSymbol('DAI')
  const usdc = TokenSymbol('USDC')
  const usds = TokenSymbol('USDS')

  if (chainId === base.id) {
    if (from.symbol === usdc && to.symbol === usds) {
      return 'base-usdc-usds'
    }

    if (from.symbol === usds && to.symbol === usdc) {
      return 'base-usds-usdc'
    }
  }

  if (chainId === arbitrum.id) {
    if (from.symbol === usdc && to.symbol === usds) {
      return 'arbitrum-usdc-usds'
    }

    if (from.symbol === usds && to.symbol === usdc) {
      return 'arbitrum-usds-usdc'
    }
  }

  if (chainId === optimism.id) {
    if (from.symbol === usdc && to.symbol === usds) {
      return 'optimism-usdc-usds'
    }

    if (from.symbol === usds && to.symbol === usdc) {
      return 'optimism-usds-usdc'
    }
  }

  if (chainId === unichain.id) {
    if (from.symbol === usdc && to.symbol === usds) {
      return 'unichain-usdc-usds'
    }

    if (from.symbol === usds && to.symbol === usdc) {
      return 'unichain-usds-usdc'
    }
  }

  if (from.symbol === dai && to.symbol === usdc) {
    return 'dai-usdc'
  }

  if (from.symbol === usdc && to.symbol === dai) {
    return 'usdc-dai'
  }

  if (from.symbol === usdc && to.symbol === usds) {
    return 'usdc-usds'
  }

  if (from.symbol === usds && to.symbol === usdc) {
    return 'usds-usdc'
  }

  if (from.symbol === usds && to.symbol === dai) {
    return 'usds-dai'
  }

  if (from.symbol === dai && to.symbol === usds) {
    return 'dai-usds'
  }

  raise('Swap action type not recognized')
}
